var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simplifiedWord",class:_vm.difficulty},[_c('div',{staticClass:"word"},[_vm._v(_vm._s(_vm._f("obscure")(_vm.word)))])])}
var staticRenderFns = []

export { render, staticRenderFns }